import { Component, OnInit, OnDestroy } from '@angular/core';
import { NotificationDto, NotificationService } from '@proxy/notifications';
import { PagedAndSortedResultRequestDto } from '@abp/ng.core';
import { NotificationStateService } from 'src/app/services/notification-state.service';
import { finalize } from 'rxjs/operators';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-notification-panel',
  templateUrl: './notification-panel.component.html',
  styleUrls: ['./notification-panel.component.scss'],
})
export class NotificationPanelComponent implements OnInit, OnDestroy {
  public isOpen = false; // Controla a visibilidade do painel
  notifications: NotificationDto[] = [];
  isLoading = false;
  isLastPage = false;
  page = 0;
  readonly pageSize = 15;
  private openSubscription: Subscription;

  constructor(
    private notificationService: NotificationService,
    private notificationStateService: NotificationStateService
  ) {}

  ngOnInit(): void {
    this.openSubscription = this.notificationStateService.openPanel$.subscribe(() => {
      this.openPanel();
    });
  }

  ngOnDestroy(): void {
    if (this.openSubscription) {
      this.openSubscription.unsubscribe();
    }
  }

  public openPanel(): void {
    if (this.isOpen) return;

    this.isOpen = true;
    document.body.style.overflow = 'hidden';

    // Reseta e carrega as notificações apenas ao abrir
    this.resetAndLoadNotifications();
    this.markAllAsRead();
  }

  public closePanel(): void {
    if (!this.isOpen) return;

    this.isOpen = false;
    document.body.style.overflow = 'auto';
  }

  private resetAndLoadNotifications() {
    this.notifications = [];
    this.page = 0;
    this.isLastPage = false;
    this.loadNotifications();
  }

  private markAllAsRead() {
    this.notificationService.markAllAsRead().subscribe(() => {
      this.notificationStateService.clearUnreadCount();
    });
  }

  loadNotifications(onScroll = false) {
    if (this.isLoading || (onScroll && this.isLastPage)) return;

    this.isLoading = true;
    const input: PagedAndSortedResultRequestDto = {
      maxResultCount: this.pageSize,
      skipCount: this.page * this.pageSize,
    };

    this.notificationService.getList(input)
      .pipe(finalize(() => this.isLoading = false))
      .subscribe(result => {
        this.notifications = [...this.notifications, ...result.items];
        this.page++;
        if (result.items.length < this.pageSize) {
          this.isLastPage = true;
        }
      });
  }

  delete(id: string) {
    this.notificationService.delete(id).subscribe(() => {
      this.notifications = this.notifications.filter(n => n.id !== id);
    });
  }
}
